import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from './App';
import Player from './routes/Player';
import reportWebVitals from './reportWebVitals';
import PlayerRanking from './routes/PlayerRanking';
import CountriesRanking from './routes/CountriesRanking';
import Insights from './routes/Insights';
import OldInsights from './routes/OldInsights';
import 'primeflex/primeflex.css';
import { useLocation } from "react-router-dom";
import Faq from './routes/Faq';
import AboutPage from './routes/About';
import LandingPage from './routes/LandingPage';
import InsightsPlayersOfTheDay from './routes/insights/InsightsPlayersOfTheDay';
import InsightsPlayersOfTheWeek from './routes/insights/InsightsPlayersOfTheWeek';

function PlayerWrapper() {
  const location = useLocation();
  return <Player key={location.pathname} />;
}

export default function Index() { 
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<LandingPage />} />
          <Route path="players/" element={<PlayerRanking />} />
          <Route path="countries/" element={<CountriesRanking />} />
          <Route path="oldinsights/" element={<OldInsights />} />
          <Route path="insights/" element={<Insights />}>
            <Route path="playersOfTheDay/" element={<InsightsPlayersOfTheDay />} />
            <Route path="playersOfTheWeek/" element={<InsightsPlayersOfTheWeek />} />
          </Route>
          <Route path="player/:playerId" element={<PlayerWrapper />} />
          <Route path="faq/" element={<Faq />} />
          <Route path="about/" element={<AboutPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
